import {
  trackingAllowed,
  analyticsAvailable,
  EVENT_TRACKING_STORAGE_KEY as STORAGE_KEY,
  identifier,
} from '../'
import { setItem } from '../storage'
import { execute, hasFeature } from '~/utils/nativeBridge'

export const track = async (handle, payload) => {
  const hasNativeFeature = await hasFeature('canTrackSegmentEvent')

  if (hasNativeFeature) {
    return execute('trackSegmentEvent', {
      trackingEvent: handle,
      isFromWebView: true,
      ...payload,
    })
  }

  if (trackingAllowed() && analyticsAvailable()) {
    global.analytics.track(handle, { ...payload, ...identifier })
  } else {
    setItem(STORAGE_KEY, { handle, payload })
  }
}
